module.exports = __webpack_public_path__ + "img/article_shubba.94a119c8.jpg";